import styled from 'styled-components';

export const CancelMainWrapper = styled.div(
    props => `
        width:100%;
        display: flex;
        background-color: ${props.theme.colors.grey.lightf2};
    `
);

export const CancelOuterWrap = styled.div(
    props => `
        width:100%;
        max-width: 1000px;
        margin: 0 auto;
        padding: ${props.theme.spacing.large.l25} 0;
        display: flex;
    `
)